// import React from 'react';

const useFormValidation = (formData) => {
  const validateForm = () => {
    const errors = {};
    
    // Validation du nom et prénom
    if (!formData.nom.trim()) errors.nom = 'Le nom est requis';
    if (!formData.prenom.trim()) errors.prenom = 'Le prénom est requis';
    
    // Validation du téléphone (format français)
    if (formData.telephone.trim()) {
      const phoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
      if (!phoneRegex.test(formData.telephone)) {
        errors.telephone = 'Format de téléphone invalide';
      }
    }
    
    // Validation de l'email
    if (!formData.email.trim()) {
      errors.email = 'L\'email est requis';
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@plateau-urbain\.com$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = 'L\'email doit être au format prenom.nom@plateau-urbain.com';
      }
    }
    
    // Validation du mot de passe
    if (!formData.password) {
      errors.password = 'Le mot de passe est requis';
    } else if (formData.password.length < 8) {
      errors.password = 'Le mot de passe doit contenir au moins 8 caractères';
    } else {
      // eslint-disable-next-line no-useless-escape
      const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"|,.<>/?]/.test(formData.password);
      const hasUpperCase = /[A-Z]/.test(formData.password);
      const hasNumber = /[0-9]/.test(formData.password);
      
      if (!hasUpperCase || !hasNumber || !hasSpecialChar) {
        errors.password = 'Le mot de passe doit contenir au moins une majuscule, un chiffre et un caractère spécial';
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };

  return { validateForm };
};

export default useFormValidation;
